import { render, staticRenderFns } from "./usuarioPermisos.vue?vue&type=template&id=44014824&"
import script from "./usuarioPermisos.vue?vue&type=script&lang=js&"
export * from "./usuarioPermisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports